<div class="font-body-1 ms-large-b">
  <h3 class="ms-small-b">{{ 'SERVICE_FORMS.serviceForms.safDownloadableForm.title' | finLocalization }}</h3>
  <span>{{ 'SERVICE_FORMS.serviceForms.safDownloadableForm.description' | finLocalization }}</span>

  <form class="ms-small-t">
    <div class="ms-medium-b">
      <div class="flex">
        <div class="flex-1 ms-small-r">
          <fcom-text-input
            [parentForm]="form"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.firstName'"
            [controlName]="'firstName'"
            [displayMargin]="false"
          ></fcom-text-input>
        </div>
        <div class="flex-1">
          <fcom-text-input
            [parentForm]="form"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.lastName'"
            [controlName]="'lastName'"
            [displayMargin]="false"
          ></fcom-text-input>
        </div>
      </div>
    </div>

    <div class="ms-medium-b">
      <fcom-text-input
        [parentForm]="form"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.companyName'"
        [controlName]="'company'"
        [displayMargin]="false"
      ></fcom-text-input>
    </div>

    <div class="ms-large-b">
      <fcom-text-input
        [parentForm]="form"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
        [controlName]="'email'"
        [displayMargin]="false"
      ></fcom-text-input>
    </div>

    <fcom-button
      [text]="'SERVICE_FORMS.serviceForms.safDownloadableForm.button' | finLocalization"
      [icon]="{
        name: SvgLibraryIcon.ARROW_DOWN,
        position: IconPosition.RIGHT,
      }"
      (clickBtn)="handleDownload()"
    ></fcom-button>
  </form>
</div>
